<template>
  <div  class="aaaaa">
    <div class="bbbbb">
    <!-- 头部部分 -->
    <div ref="search_d">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="18">
          <el-button type="primary" @click="newBtn">新建</el-button>
        </el-col>
        <el-col :span="6">
          <el-input
            placeholder="请输入内容"
            v-model="queryInfo.condition.queryKey"
            class="input-with-select"
            clearable
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getList"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
    </div>

    <!-- 表格部分 -->
    <div>
      <el-table
        border
        ref="table"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :height="height"
      >
        <el-table-column
          label="序号"
          type="index"
          width="50"
          align="center"
        ></el-table-column>

        <el-table-column label="商家编码" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.merchantCode }}</template>
        </el-table-column>
        <el-table-column label="商家名称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.merchantName }}</template>
        </el-table-column>
        <el-table-column label="联系人" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.linkName }}</template>
        </el-table-column>
        <el-table-column label="联系号码" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.linkPhone }}</template>
        </el-table-column>
        <el-table-column label="地址" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.address }}</template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row)" size="small" style="width:50px">编辑</el-button>
              <el-button type="text" @click="downloadCode(scope.row)" size="small" style="width:100px">下载二维码</el-button>
            </template>
          </el-table-column>

      </el-table>
      <!-- 分页 -->
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="labelType == 'add' ? '新增' : '编辑'"
      :visible.sync="showDialog"
      width="800px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="商家名称" prop="merchantName">
              <el-input
                v-model="form.merchantName"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="联系人：" prop="siteName">
              <el-input
                v-model="form.linkName"
                placeholder="请输入名称"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="联系号码" prop="linkPhone">
              <el-input
                v-model="form.linkPhone"
                placeholder="请输入号码" :disabled="labelType != 'add'" :readonly="labelType != 'add'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址" prop="address">
              <el-input v-model="form.address" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="labelType == 'add'">
            <el-form-item label="密码" prop="password">
              <el-input v-model="password" placeholder="请输入密码"></el-input>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labelType: "add",
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {},
      },
      form: {},
      password: "",
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, //表格高度
      headerHeight: 0,
      parentCode: JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.parentCode,
    };
  },

  created() {
    this.getList();
  },

  mounted() {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight;
      window.addEventListener("resize", this.getHeight());
    });
  },

  methods: {
    //下载二维码
    async downloadCode(row) {
      console.log("row",row.merchantCode)
      const res = await this.$http.post("merchantBaseInfo/generateCode",{merchantCode: row.merchantCode});
      if (res.data.code == 200) {
        window.open(res.data.data)
      } else {
        this.$message.error(res.data.message);
      }
    },

    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - this.headerHeight - 256;
    },

    //获取数据
    getList() {
      var that = this;
      const _data = {
        ...that.queryInfo,
      };
      _data.condition.parentCode = this.parentCode,
      that.$http
        .post("/merchantBaseInfo/merchantList", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },

    // 保存
    handleSave() {
      var that = this;
      if (!that.form.merchantName) {
        that.$notify.info({
          title: "提示",
          message: "请先输入商户名称",
          showClose: true,
        });
        return;
      }
      if (!this.form.linkPhone) {
        that.$notify.info({
          title: "提示",
          message: "请先输入联系电话",
          showClose: true,
        });
        return;
      }
      if (this.labelType == 'add' && !that.password) {
        that.$notify.info({
          title: "提示",
          message: "请先输入商户密码",
          showClose: true,
        });
        return;
      }

      if (!that.form.id) {
        const password = that.$md5(that.password);
        that.form.merchantUser = {};
        that.form.merchantUser.password = password;
        that.form.parentCode = this.parentCode
        that.$http
          .post("/merchantBaseInfo/createMerchant", that.form)
          .then(function (response) {
            if (response.data.code == 200) {
              that.$notify.success({
                title: "提示",
                message: "保存成功",
                showClose: true,
              });
              that.showDialog = false;
              that.getList();
            } else {
              that.$notify.info({
                title: "提示",
                message: response.data.message,
                showClose: true,
              });
            }
          })
          .catch(function (error) {});
      } else {
        const _form = { 
          id: that.form.id,
          merchantName: that.form.merchantName,
          linkName: that.form.linkName,
          // linkPhone: that.form.linkPhone,
          address: that.form.address,
          parentCode: this.parentCode
         };
        // _form.parentCode = this.parentCode
        that.$http
          .post("/merchantBaseInfo/update", _form)
          .then(function (response) {
            if (response.data.code == 200) {
              that.$notify.success({
                title: "提示",
                message: "保存成功",
                showClose: true,
              });
              that.showDialog = false;
              that.getList();
            } else {
              that.$notify.info({
                title: "提示",
                message: response.data.message,
                showClose: true,
              });
            }
          })
          .catch(function (error) {});
      }
    },

    //修改
    edit(row) {
      this.showDialog = true;
      this.labelType = "edit";
      this.form = JSON.parse(JSON.stringify(row));
    },

    // 删除当前行
    //    handleDelte (id) {
    //      del({ id: id }).then(res => {
    //        if (res.code == 200) {
    //         this.$message.success('删除成功')
    //         this.getList()
    //       }
    //      })
    //    },

    // 删除用户
    async handleDelte(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantBaseInfo/delete", { id: id })
          .then(function (response) {
            if (response.data.code == 200) {
              that.$notify.success({
                title: "提示",
                message: "删除成功",
                showClose: true,
              });
              that.getList();
            } else {
              that.$notify.info({
                title: "提示",
                message: response.data.message,
                showClose: true,
              });
            }
          });
      }
    },

    //新增按钮
    newBtn() {
      this.labelType = "add";
      this.showDialog = true;
      this.form = {};
    },

    // 修改页数大小
    handleSizeChange(val) {
      this.queryInfo.pageSize = val;
      this.getList();
    },

    // 获取当前页面
    handleCurrentChange(val) {
      this.queryInfo.currPage = val;
      this.getList();
    },
  },
};
</script>

<style scoped></style>
